export default "__VITE_ASSET__B0w8X$we__"